export default __webpack_public_path__ + "static/media/31.4f945d02.png";